module.exports = __webpack_public_path__ + "static/media/bluebg.a41d17ae.jpg";